module.exports = __webpack_public_path__ + "img/2176.9fb74d6e.gif";